import {
  Layout,
  useSidebarState,
  useCreatePath,
  UserMenu,
  TitlePortal,
} from "react-admin";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";

import {
  Menu,
  ArrowBackIos,
  ArrowForwardIos,
  PointOfSale,
  AssignmentInd,
  Hotel,
  //Paid,
  Home,
  ExpandMore,
  ExpandLess,
  Receipt,
} from "@mui/icons-material";
import { ListItemIcon } from "@mui/material";
//import AppBreadcrumbs from "./AppBreadcrumbs";

const menuData = [
  { icon: <Home />, label: "Inicio", path: "/" },
  {
    icon: <PointOfSale />,
    label: "Movimientos",
    path: { resource: "movimientos", type: "list" },
  },
  {
    icon: <Hotel />,
    label: "Huspedes & Convenios",
    subitems: [
      {
        label: "Huespedes",
        path: { resource: "huespedes", type: "list" },
      },
      {
        label: "Obras Sociales",
        path: { resource: "obrasSociales", type: "list" },
      },
      {
        label: "Convenios",
        path: { resource: "conveniosMaster", type: "list" },
      },
    ],
  },
  {
    icon: <AssignmentInd />,
    label: "Personal",
    subitems: [
      { label: "Personal", path: { resource: "personal", type: "list" } },
      {
        label: "Valor Honorarios",
        path: { resource: "honorariosValorHora", type: "list" },
      },
      {
        label: "Liquidaciones",
        path: { resource: "horasMensualesPersonal", type: "list" },
      },
    ],
  },
  {
    icon: <Receipt />,
    label: "Facturas",
    path: { resource: "facturas", type: "list" },
  },
];

const SidebarMenu = () => {
  const [sidebarState, setSidebarState] = useSidebarState();
  const [expand, setExpand] = React.useState({});
  const navigate = useNavigate();
  const createPath = useCreatePath();

  const handleClick = (index, item) => {
    if (item.path) {
      const pathToNavigate = item.path.resource
        ? createPath(item.path)
        : item.path;
      setSidebarState(false);
      navigate(pathToNavigate);
    }
    setExpand((prevOpen) => {
      if (prevOpen[index]) setSidebarState(true);
      return {
        ...prevOpen,
        [index]: !prevOpen[index],
      };
    });
  };

  const renderMenuItems = (items, parentIndex = "") => {
    return items.map((item, index) => {
      const itemIndex = `${parentIndex}_${index}`;
      const hasSubitems = item.subitems && item.subitems.length > 0;

      return (
        <React.Fragment key={itemIndex}>
          <ListItem onClick={() => handleClick(itemIndex, item)}>
            <ListItemIcon sx={{ minWidth: "32px" }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
            {sidebarState && hasSubitems ? (
              expand[itemIndex] ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )
            ) : null}
          </ListItem>
          {sidebarState && hasSubitems && (
            <Collapse in={expand[itemIndex]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {renderMenuItems(item.subitems, itemIndex)}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      );
    });
  };

  return <List component="nav">{renderMenuItems(menuData)}</List>;
};

const MyAppBar = () => {
  const navigate = useNavigate();
  const [sidebarState, setSidebarState] = useSidebarState();
  return (
    <AppBar sx={{ backgroundColor: "#134f5c" }}>
      <Toolbar
        sx={{ minHeight: "46px !important", paddingLeft: "10px !important" }}
      >
        <IconButton onClick={() => setSidebarState(!sidebarState)}>
          <Menu color="white" />
        </IconButton>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIos color="warning" />
        </IconButton>
        <IconButton onClick={() => navigate("/")}>
          <Home color="warning" />
        </IconButton>
        <IconButton onClick={() => navigate(1)}>
          <ArrowForwardIos color="warning" />
        </IconButton>
        <TitlePortal />
        <UserMenu label="."></UserMenu>
      </Toolbar>
    </AppBar>
  );
};

export const MainLayout = (props) => (
  <Layout {...props} menu={SidebarMenu} appBar={MyAppBar} />
);
